import { Quote } from "lucide-react";

export function Testimonials() {
  const testimonials = [
    {
      quote: "HarmCheck is the 'always-on' solution to the risk of problematic communications. This technology has broad application to use cases across all industries.",
      name: "David Lang",
      title: "Former Head of Global Compliance",
      company: "RBC",
      logo: "logos/rbc.webp",
      logoHeight: "h-12",
      logoWidth: 37,
      logoHeightPx: 48
    },
    {
      quote: "HarmCheck matters because careless or intended messages can cause irreparable harm — legally, internally, reputationally, and to a company’s morale and leadership. Catching it before it goes out brings profound value to both enterprises and individuals involved.",
      name: "Philip Brittan",
      title: "CEO, CTO & VP",
      company: "Google",
      logo: "logos/google-color.webp",
      logoHeight: "h-12",
      logoWidth: 115,
      logoHeightPx: 48
    },
    {
      quote: "Unfortunately, discriminatory communication still occurs and is a nightmare for any firm to deal with. HarmCheck provides an effective and modern solution to this compliance problem.",
      name: "James Wylie",
      title: "Expert Compliance Lawyer, Formerly",
      company: "HUD & CFPB",
      logo: "logos/cfpb.webp",
      logoHeight: "h-12",
      logoWidth: 176,
      logoHeightPx: 48
    },
    {
      quote: "If anyone can bring a breakthrough communication technology to life, it’s the Alphy team. I’ve seen HarmCheck highlight harmful, unethical, and unlawful language in real-time — it’s stellar.",
      name: "Karan Gupta",
      title: "CEO",
      company: "Voicebox",
      logo: "logos/voicebox.webp",
      logoHeight: "h-12",
      logoWidth: 164,
      logoHeightPx: 48
    }
  ];

  return (
    <section className="py-24 border-b border-border/40 bg-background">
      <div className="container mx-auto px-0 md:px-6">
        <div className="text-center mb-16 px-6 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            What industry leaders are saying
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Trusted by compliance leaders, legal experts, and enterprise executives.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="border border-border/50 bg-card p-8 relative group hover:border-primary/30 transition-colors"
            >
              <p className="text-foreground mb-6 leading-relaxed">
                "{t.quote}"
              </p>
              <div className="mb-6">
                <p className="font-bold text-foreground">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.title}, {t.company}</p>
              </div>
              <img
                src={`${import.meta.env.BASE_URL}${t.logo}`}
                alt={`${t.company} logo`}
                width={t.logoWidth}
                height={t.logoHeightPx}
                loading="lazy"
                decoding="async"
                className={`${t.logoHeight || "h-8"} w-auto object-contain object-left`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
